module.exports = __webpack_public_path__ + "img/ps-3.08dd5aac.jpg";